import { render, staticRenderFns } from "./studentQuestions.vue?vue&type=template&id=7c926af9&scoped=true"
import script from "./studentQuestions.vue?vue&type=script&lang=js"
export * from "./studentQuestions.vue?vue&type=script&lang=js"
import style0 from "./studentQuestions.vue?vue&type=style&index=0&id=7c926af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c926af9",
  null
  
)

export default component.exports